const firebaseConfig = {
    apiKey: "AIzaSyC26Ej0uEI751_SeJcZnQMw_00Jc95euRU",
    authDomain: "alifaonline-shop.firebaseapp.com",
    projectId: "alifaonline-shop",
    storageBucket: "alifaonline-shop.appspot.com",
    messagingSenderId: "982464975028",
    appId: "1:982464975028:web:3f6aa25f92ee900b51c7e1"
  };

 export default firebaseConfig;